import React from 'react';
import Obfuscate from 'react-obfuscate';
import contactStyles from './contactinfo.module.sass';

export default props => {
  return (

    <div className={contactStyles.contactinfo}>
      <address vocab="http://schema.org/" typeof="PostalAddress" className={contactStyles.address}>
        <span property="name" className={contactStyles.name}>Truffle Pigs Inc.</span>
        <span property="streetAddress" className={contactStyles.street}>100 Center Street</span>
        <br />
        <span>
          <span property="addressLocality">Field</span>
          ,&nbsp;
          <span property="addressRegion">BC</span>
          &nbsp;
          <span property="postalCode">V0A 1G0</span>
        </span>
        <br />
        <span property="addressCountry" className={contactStyles.country}>Canada</span>
      </address>
      <Obfuscate
        className={contactStyles.anchor}
        email='oink@trufflepigs.com'
        headers={
          { subject: 'Email from TrufflePigs.com' }
        }
      />
      <br />
      <a href="tel:250-343-6303" className={contactStyles.anchor}>250.343.6303</a>
    </div>

  );
};
